import { dedup } from '~/lib/dedup'

export const getPcPaginationIndexes = (
  currentPage: number,
  totalPage: number
): (number | '...')[] => {
  if (totalPage < 1) return [1]
  if (currentPage < 1) return getPcPaginationIndexes(1, totalPage)
  if (totalPage < currentPage)
    return getPcPaginationIndexes(totalPage, totalPage)

  const indexes: (number | '...')[] = dedup(
    [
      1,
      ...[
        currentPage,
        currentPage - 1,
        currentPage + 1,
        currentPage - 2,
        currentPage + 2,
        currentPage - 3,
        currentPage + 3,
        currentPage - 4,
        currentPage + 4,
      ]
        // eslint-disable-next-line yoda
        .filter((i) => 1 <= i && i <= totalPage)
        .slice(0, 5),
      totalPage,
    ].sort((a, b) => a - b)
  )
  // total:1,current:1のときなど '...' を挿入しなくてよいケース
  if (indexes.length >= totalPage) return indexes

  if (!indexes.includes(2)) {
    indexes.splice(1, 0, '...')
  }
  if (!indexes.includes(totalPage - 1)) {
    indexes.splice(-1, 0, '...')
  }
  return indexes
}
